import dayjs from "dayjs";
import {User} from "../user/user";
import {Product} from "../product/product";

export class Cart {
    constructor() {
        this.id = '';
        this.owningUser = new User();
        this.items = new Array<CartItem>();
        this.itemsTotal = 0;
        this.taxTotal = 0;
        this.shippingMode = "";
        this.shippingTotal = 0;
        this.total = 0;
        this.lastUpdate = dayjs();
    }

    id: string;
    owningUser: User;
    items: Array<CartItem>;
    itemsTotal: number;
    shippingMode: string;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    lastUpdate: dayjs.Dayjs;
}

export class ConfigurableItem {
    constructor() {
        this.cartItem = new CartItem();
        this.cartItemAddons = new Array<CartItemAddon>();
    }
    cartItem: CartItem;
    cartItemAddons: Array<CartItemAddon>;
}

export class CartItem {
    constructor() {
        this.id = undefined;
        this.productId = '';
        this.quantity = 0;
        this.imageUrl = "";
        this.product = new Product();
        this.taxTotal = 0;
        this.addons = new Array<CartItemAddon>();
        this.isOutOfStock = false;
    }
    id: string|undefined;
    productId: string;
    product: Product;
    taxTotal: number;
    quantity: number;
    imageUrl: string;
    addons: Array<CartItemAddon>;
    isOutOfStock?: boolean;
}

export class AddonCartHelper {
    constructor() {
        this.id = '';
        this.selectedAddon = new CartItemAddon();
    }
    id: string;
    selectedAddon: CartItemAddon;
}

export class CartItemAddon {
    constructor() {
        this.id = '';
        this.item = new CartItem();
        this.addonName = '';
        this.addonSku = '';
        this.selectedOptionId = '';
        this.selectedOptionName = '';
        this.selectedOptionPrice = 0;
        this.selectedOption = undefined;
        this.sequence = 0;
        this.selectedQuantity = 1;
    }

    id: string;
    item: CartItem;
    addonName: string;
    addonSku: string;
    selectedOptionName: string;
    selectedOptionId: string | null;
    selectedOption: CartItemOption | undefined ;
    selectedOptionPrice: number;
    sequence: number;
    selectedQuantity: number;
}

export class CartItemOption {
    constructor() {
        this.id = '';
        this.name = '';
        this.sku = '';
        this.parentSku = '';
        this.price = 0;
        this.stock1 = 0;
    }

    id: string;
    name: string;
    sku: string;
    parentSku: string;
    price: number;
    stock1: number;
}

